module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_kongdoo_m.2b862a7924459c1ec5f4a2f48d5f37b1.png";